/* Shop Manufaktur: Hulk-Mengenrabatt (Legacy-Modus) im Warenkorb-Slider und auf /cart.
   1. Kein Springen: Nach jeder Mengenaenderung baut das Theme den Warenkorb neu (ohne Rabatt) und Hulk
      setzt den Rabattpreis erst nach eigenem API-Aufruf ein. Bis dahin bleiben Preis, Hinweis und
      Etikett an ihrem Platz, aber unsichtbar; der alte Inhalt haelt nur die Hoehe.
      Ohne Hulk-Antwort nach 3 s: Theme-Inhalt.
   2. Etikett "Mengenrabatt – Sie sparen X" in .sm-hulk-label[data-key] (Platzhalter im Liquid),
      im Stil der Theme-Rabattzeilen (ul.discounts > li.discounts__discount). */
(function () {
  var WAIT = 'sm-hulk-wait';
  var TIMEOUT = 3000;
  var LINE = '[data-hulkapps-line-price][data-key],[data-hulkapps-ci-price][data-key]';
  var NOTE = '.hulkapps-reminder[data-key],.sm-hulk-label[data-key]';
  var TOTAL = '.sm-hulk-total,[data-hulkapps-cart-total]';
  var LABEL_TEXT = 'Mengenrabatt – Sie sparen ';
  var timer = null;
  var money = window.Intl ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }) : null;

  var css = document.createElement('style');
  css.textContent =
    LINE + ',' + NOTE + ',' + TOTAL + '{transition:opacity .15s ease}' +
    '.' + WAIT + '{opacity:0;transition:none!important}' +
    '.sm-hulk-label:empty{display:none}';
  document.head.appendChild(css);

  function waiting() {
    return document.querySelectorAll('.' + WAIT);
  }

  function reveal(restorePlain) {
    clearTimeout(timer);
    waiting().forEach(function (el) {
      if (restorePlain && el.smPlain !== undefined) el.innerHTML = el.smPlain;
      delete el.smPlain;
      el.classList.remove(WAIT);
    });
  }

  function renderLabels(data) {
    var items = (data && data.cart && data.cart.items) || [];
    var byKey = {};
    items.forEach(function (it) { byKey[it.key] = it; });
    document.querySelectorAll('.sm-hulk-label[data-key]').forEach(function (el) {
      var it = byKey[el.getAttribute('data-key')];
      var saved = it ? Number(it.original_line_price) - Number(it.discounted_line_price) : 0;
      if (!(saved >= 0.005)) {
        el.innerHTML = '';
        return;
      }
      var amount = money ? money.format(saved) : saved.toFixed(2).replace('.', ',') + ' €';
      el.innerHTML = '<li class="discounts__discount"><i class="at at-tag-l" aria-hidden="true"></i> ' +
        LABEL_TEXT + amount + '</li>';
    });
  }

  function wrap(fn) {
    if (typeof fn !== 'function' || fn.smWrapped) return fn;
    var wrapped = function (data) {
      // Platzhalter zurueck auf den neuen Theme-Inhalt, Hulk ueberschreibt ihn im selben Durchlauf
      waiting().forEach(function (el) {
        if (el.smPlain !== undefined) el.innerHTML = el.smPlain;
      });
      try {
        return fn.apply(this, arguments);
      } finally {
        try { renderLabels(data); } catch (e) {}
        reveal(false);
      }
    };
    wrapped.smWrapped = true;
    return wrapped;
  }

  // Hulk setzt window.hulkappsShowCartDiscounts selbst – je nach Ladereihenfolge vor oder nach uns
  function hookHulk() {
    var current = window.hulkappsShowCartDiscounts;
    if (typeof current === 'function') {
      window.hulkappsShowCartDiscounts = wrap(current);
      return;
    }
    try {
      var stored;
      Object.defineProperty(window, 'hulkappsShowCartDiscounts', {
        configurable: true,
        get: function () { return stored; },
        set: function (fn) { stored = wrap(fn); }
      });
    } catch (e) {}
  }

  // gleiche Stelle im alten und neuen Markup: Feld-Art + Artikel-Key (auf /cart gibt es Preise doppelt)
  function slot(el) {
    var kind = el.hasAttribute('data-hulkapps-ci-price') ? 'ci'
      : el.hasAttribute('data-hulkapps-line-price') ? 'line'
      : el.classList.contains('sm-hulk-label') ? 'label' : 'rem';
    return kind + '|' + el.getAttribute('data-key');
  }

  function collectOld(nodes) {
    var old = {};
    nodes.forEach(function (n) {
      if (n.nodeType !== 1) return;
      var list = n.matches(LINE + ',' + NOTE) ? [n] : n.querySelectorAll(LINE + ',' + NOTE);
      list.forEach(function (el) {
        var k = slot(el);
        (old[k] = old[k] || []).push(el.innerHTML);
      });
    });
    return old;
  }

  function isRerender(n) {
    if (n.nodeType !== 1) return false;
    return n.matches(LINE + ',' + NOTE + ',' + TOTAL) ||
      !!n.querySelector(LINE + ',' + NOTE + ',' + TOTAL);
  }

  function onMutations(mutations) {
    var added = [];
    var removed = [];
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (isRerender(n)) added.push(n); });
      m.removedNodes.forEach(function (n) { removed.push(n); });
    });
    if (!added.length) return;
    var old = collectOld(removed);
    added.forEach(function (n) {
      var list = n.matches(LINE + ',' + NOTE) ? [n] : n.querySelectorAll(LINE + ',' + NOTE);
      list.forEach(function (el) {
        var prev = (old[slot(el)] || []).shift();
        el.smPlain = el.innerHTML;
        if (prev !== undefined) el.innerHTML = prev;
        el.classList.add(WAIT);
      });
      (n.matches(TOTAL) ? [n] : n.querySelectorAll(TOTAL)).forEach(function (el) {
        el.classList.add(WAIT);
      });
    });
    clearTimeout(timer);
    timer = setTimeout(function () { reveal(true); }, TIMEOUT);
  }

  function init() {
    // Hulk lief evtl. schon vor uns: Etiketten aus dem letzten Ergebnis nachziehen
    if (window.hulkapps && window.hulkapps.discounts) {
      try { renderLabels(window.hulkapps.discounts); } catch (e) {}
    }
    if (!window.MutationObserver) return;
    var roots = [document.querySelector('cart-drawer')];
    var page = document.querySelector('form#cart');
    if (page) roots.push(page.closest('main') || page.closest('.shopify-section') || page.parentNode);
    roots.filter(Boolean).forEach(function (root) {
      new MutationObserver(onMutations).observe(root, { childList: true, subtree: true });
    });
  }

  hookHulk();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
